import { useEffect, useState } from 'react'
import ScrollReveal from 'scrollreveal'
import sanityClient from '../../client'
import imageUrlBuilder from '@sanity/image-url'

const builder = imageUrlBuilder(sanityClient)
function urlFor (source) {
  return builder.image(source)
}

const Projects = () => {
  useEffect(() => {
    const scroll = ScrollReveal({
      origin: 'top',
      distance: '5rem',
      duration: 2000,
      reset: true
    })

    scroll.reveal('.project-item', { delay: 600, interval: 500 })
  }, [])

  const [projectData, setProjectData] = useState(null)

  useEffect(() => {
    sanityClient
      .fetch(
        `*[_type == "project"]{
            title, 
            description,
            projectType,
            website_url,
            github_url,
            tags,
            mainImage{
                asset->{
                    _id,
                    url
                },
                alt
            }
        }`
      )
      .then(data => setProjectData(data))
      .catch(console.error)
  }, [])

  console.log(projectData?.length)
  return (
    <section id='projects'>
      <div className='projects container'>
        <div className='projects-header'>
          <h1 className='section-title'>
            Project<span>s</span>
          </h1>
          <p className='title_info'>
            The following are the current projects have done and that am still
            improving.
          </p>
        </div>
        <div className='all-projects'>
          {projectData &&
            projectData.map((project, index) => (
              <div key={index} className='project-item'>
                <div className='project-info'>
                  <h1>{project.title}</h1>
                  <p>{project.description}</p>

                  <div className='project-review'>
                    {project.website_url && (
                      <a
                        href={project.website_url}
                        target='_blank'
                        rel='noopener noreferrer'
                      >
                        Live Demo
                      </a>
                    )}

                    {project.github_url && (
                      <a
                        href={project.github_url}
                        target='_blank'
                        rel='noopener noreferrer'
                      >
                        <box-icon
                          animation='burst-hover'
                          size='lg'
                          type='logo'
                          name='github'
                        ></box-icon>
                      </a>
                    )}
                  </div>
                </div>

                <div className='project-img'>
                  <img
                    src={urlFor(project.mainImage).url()}
                    alt={project.title}
                  />
                </div>
              </div>
            ))}
        </div>
      </div>
    </section>
  )
}

export default Projects
